<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .newDetails{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background: url("../assets/img/bg.png")no-repeat;
    background-position-y:top;
    width: 100%;
    overflow: hidden;
  }
  .newDetails .navbox{
    background-color: #c42428;
  }
  .newDetails .nav{
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    margin-top: 60px;
  }
  .newDetails .nav img{
    float: left;
    margin-right: 90px;
    margin-top: 35px;
  }
  .newDetails .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .newDetails .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 140px;
    text-align: center;
    line-height: 120px;
    color: #ebbfbf;
    font-size: 20px;
    font-weight: 900;
    cursor: pointer;
  }
  .newDetails .nav ul li:hover{
    background-color: #b62125;
    color: #fffefe;
    background-position: 0 21px;
  }
  .newDetails .nav ul li.on{
    background-color: #b62125;
    color: #fffefe;
    background-position: 0 21px;
  }
  .newDetails .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .newDetails .content {
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 195px;
  }
  .newDetails .content .title{
    margin-top: 100px;
    color: #191919;
    font-size: 36px;
    font-weight: 900;
    margin-bottom: 30px;
  }
  .newDetails .content .title img{
    margin-right: 15px;
  }
  .newDetails .content .details {
    padding:60px;
    margin-bottom: 100px;
    background-color: #ffffff;
  }
  .newDetails .content .details .title1{
    color: #333;
    font-size: 36px;
    margin-bottom: 5px;
    font-weight: 900;
  }
  .newDetails .content .details .timer {
    margin-bottom: 16px;
    color: #949494;
  }
  .newDetails .content .details .text {
    color: #333;
    font-size: 16px;
  }
</style>
<template>
  <div class="newDetails">
    <myhead></myhead>
    <div class="navbox">
      <nav class="nav">
        <img src="../assets/img/logo.png" alt=""/>
        <ul>
          <li @click="urlFun('/home')">首页</li>
          <li class="on" @click="urlFun('/news')">新闻</li>
          <li @click="urlFun('/rules')">规则</li>
          <li @click="urlFun('/videoList')">视频</li>
          <li @click="urlFun('/live')">直播</li>
        </ul>
      </nav>
    </div>
    <div class="content">
      <div class="title"><img src="../assets/img/title.png" alt=""/>新闻</div>
      <div class="details">
        <p class="title1">{{newsList.newsTitle}}</p>
        <p class="timer">{{newsList.createTime}}</p>
        <p class="text" v-html="newsList.content"></p>
      </div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
    import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  export default {
    name: 'NewDetails',
    components: {
      myhead,
      mybottom
    },
    data () {
      return {
        newsList:"",
      }
    },

    computed:{

    },
    mounted(){
      this.NewDetailsData()
    },
    methods:{
      NewDetailsData(){
        let _this=this;
        let formd=new FormData()
        formd.append("seriesId",22)
        formd.append("newsId",this.$route.query.nid)
        this.$axios.post("http://admin.matchon.net//client/getNewsInfo",formd).then((data) => {
          if(data.data.code==200){
            _this.newsList=data.data.data;
          }
        });
      },
      urlFun(url){
        this.$router.push({path:url})
      },
    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/NewDetails.vue